import {RegionModel} from "./RegionModel";

export class SharedRegion {
  region1Obj: RegionModel;
  region2Obj: RegionModel;


  constructor(region1Obj?: RegionModel, region2Obj?: RegionModel) {
    this.region1Obj = region1Obj;
    this.region2Obj = region2Obj;
  }
}
